/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import breakpoints from '@userzoom-themes/peach/constants/breakpoints';

/**
 * Devices
 */

// @gearz/grid SMALL.BREAKPOINT_MIN
export const UiBreakpoint = breakpoints.small - 1;

export const Devices = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  Desktop: 'desktop',
  Any: '*',
} as const;

export const Browsers = {
  Chrome: 'chrome',
  Firefox: 'firefox',
  Safari: 'safari',
  Edge: 'edge',
  MobileSafari: 'mobile_safari',
  Any: '*',
} as const;

export const Os = {
  Ios: 'ios',
  Android: 'android',
  WindowsPhone: 'windows_phone',
  BlackBerry: 'blackberry',
  MacOs: 'mac_os',
  Windows: 'windows',
  Linux: 'linux',
  Any: '*',
} as const;

// Do not change ordering
export const AndroidVersionNames = [
  { number: '1', name: 'No codename' },
  { number: '1', name: 'No codename' },
  { number: '1.5', name: 'Cupcake' },
  { number: '1.6', name: 'Donut' },
  { number: '2', name: 'Eclair' },
  { number: '2', name: 'Eclair' },
  { number: '2', name: 'Eclair' },
  { number: '2.2', name: 'Froyo' },
  { number: '2.3', name: 'Gingerbread' },
  { number: '2.3', name: 'Gingerbread' },
  { number: '3', name: 'Honeycomb' },
  { number: '3', name: 'Honeycomb' },
  { number: '3', name: 'Honeycomb' },
  { number: '4', name: 'Ice Cream Sandwich' },
  { number: '4', name: 'Ice Cream Sandwich' },
  { number: '4.1', name: 'Jelly Bean' },
  { number: '4.1', name: 'Jelly Bean' },
  { number: '4.1', name: 'Jelly Bean' },
  { number: '4.4', name: 'KitKat' },
  { number: '4.4', name: 'KitKat' },
  { number: '5', name: 'Lollipop' },
  { number: '5', name: 'Lollipop' },
  { number: '6', name: 'Marshmallow' },
  { number: '7', name: 'Nougat' },
  { number: '7', name: 'Nougat' },
  { number: '8', name: 'Oreo' },
  { number: '8', name: 'Oreo' },
  { number: '9', name: 'Pie' },
  { number: '10', name: 'Android' },
  { number: '11', name: 'Android' },
] as const;

/**
 * i18n
 */
export const SupportedLanguages = {
  AR: 'ar',
  CA: 'ca',
  CS: 'cs',
  DA: 'da',
  DE: 'de',
  EL: 'el',
  EN: 'en',
  ES: 'es',
  FI: 'fi',
  FR: 'fr',
  HR: 'hr',
  ID: 'id',
  IT: 'it',
  JA: 'ja',
  KO: 'ko',
  NL: 'nl',
  NO: 'no',
  PB: 'pb',
  PL: 'pl',
  RO: 'ro',
  RU: 'ru',
  SC: 'sc',
  SV: 'sv',
  TC: 'tc',
  TH: 'th',
  TR: 'tr',
  UK: 'uk',
};

export const DefaultLanguage = SupportedLanguages.EN;

export const LegalTextKeys = {
  TermsOfService: {
    snakeCase: 'terms_of_service',
    camelCase: 'termsOfService',
  },
  PrivacyPolicy: {
    snakeCase: 'privacy_policy',
    camelCase: 'privacyPolicy',
  },
};
